<template>
  <el-dialog
    v-dialogDrag
    title="考勤配置"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="mini-dialog kqpz"
    append-to-body
  >
    <el-form :model="formData" :rules="formRules" ref="formRef" v-loading="configLoading">
      <el-form-item label="指定时间" prop="Bianma">
        <!-- <el-input-number
          size="small"
          placeholder="指定天数"
          v-model="formData.Bianma"
          :min="1"
        ></el-input-number> -->
        <el-date-picker
          v-model="formData.Bianma"
          format="yyyy-MM-dd HH:mm:ss"
          size="small"
          clearable
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="text-center">
        <el-button type="primary" size="small" @click="saveBtn" :loading="saveLoading"
          >保存</el-button
        >
        <el-button size="small" @click="cancle">取消</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import DiyService from '../services/DiyService'

export default {
  name: 'ClockingInDialog',
  props: {
    visible: {
      default: false,
      type: Boolean,
    }, // 是否显示弹窗
  },
  data() {
    return {
      formData: {
        Bianma: new Date(), // 指定天数
      },
      formRules: {
        Bianma: [
          {
            required: true,
            message: '请选择指定时间',
            trigger: ['blur', 'change'],
          },
        ],
      }, // 表单规则
      configLoading: false, // 获取考勤配置数据字典loading
      saveLoading: false, // 保存按钮loading
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      },
    },
  },
  methods: {
    /**
     * @description 查询考勤配置数据字典
     */
    async getConfig() {
      const [err, res] = await DiyService.getTableData({
        FormEngineKey: 'Diy_DataDictionaryItem',
        _PageIndex: 1,
        _PageSize: 1,
        _Where: [
          {
            FormEngineKey: 'Diy_DataDictionaryItem',
            Name: 'Mingcheng',
            Type: 'Unique',
            Value: '指定天数',
          },
        ],
      })
      if (!err && res?.Code === 1 && res?.Data?.length) {
        this.formData = { ...res.Data[0] }
      }
    },

    /**
     * @description 确认选择
     */
    saveBtn() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        const [err, res] = await DiyService.updateFormData({
          FormEngineKey: 'Diy_DataDictionaryItem',
          Id: this.formData.Id, // 考勤配置id
          _FormData: {
            ...this.formData,
          },
        })
        if (!err && res?.Code === 1) {
          this.$message.success('成功')
          this.$emit('success')
          this.cancle()
        }
      })
    },

    /**
     * @description 取消
     */
    cancle() {
      this.dialogVisible = false
    },
  },

  created() {
    this.getConfig()
  },
}
</script>
<style lang="scss">
.kqpz {
  .el-form-item__error {
    position: absolute !important;
    top: 100% !important;
    left: 29% !important;
  }
}
</style>
